import React, { useState, useEffect } from "react";
import mic from "./../../resources/images/unmute.png";
import micOff from "./../../resources/images/mute.png";
import * as WebRTCHandler from "../../utils/webRTCHandler";
import { Tooltip } from "react-tooltip";
import { useSelector } from "react-redux";

const MicButton = () => {
  const micEnabled = useSelector((state)=> state.previewAudioEnabled);

  const [isMicMuted, setIsMicMuted] = useState(!micEnabled); 
  
  const handleMicButtonPressed = () => {
    const newMutedState = !isMicMuted;
    
    WebRTCHandler.toggleMic(isMicMuted);
    
    setIsMicMuted(newMutedState);
    
    updateVideoPlaceholderMutedState(newMutedState);
  };
  
  const updateVideoPlaceholderMutedState = (isMuted) => {
    const videosContainer = document.getElementById("videos_portal");
    if (!videosContainer) return;
    
    const videoContainers = videosContainer.querySelectorAll(".video_container_wrapper");
    if (videoContainers.length === 0) return;
    
    const localVideoContainer = videoContainers[0];
    const placeholder = localVideoContainer.querySelector(".video_off_placeholder");
    
    if (!placeholder) {
      console.log('No placeholder (camera is ON)');
      return; 
    }
    
    const existingIndicator = placeholder.querySelector(".mic_muted_indicator");
    
    if (isMuted && !existingIndicator) {
      const indicator = createMutedIndicator();
      placeholder.appendChild(indicator);
    } else if (!isMuted && existingIndicator) {
      placeholder.removeChild(existingIndicator);
    }
  };
  
  const createMutedIndicator = () => {
    const indicator = document.createElement("div");
    indicator.classList.add("mic_muted_indicator");
    
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("width", "20");
    svg.setAttribute("height", "20");
    
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", "M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z");
    path.setAttribute("fill", "white");
    
    svg.appendChild(path);
    indicator.appendChild(svg);
    
    return indicator;
  };

  return (
    <div className="video_button_container">
      <Tooltip id="tooltip-mic" place="top" />
      <img
        className={`video_button_image ${isMicMuted ? "muted" : ""}`}
        src={isMicMuted ? micOff : mic}
        alt={isMicMuted ? "Unmute" : "Mute"}
        onClick={handleMicButtonPressed}
        data-tooltip-id="tooltip-mic"
        data-tooltip-content={isMicMuted ? "Unmute" : "Mute"}
      />
    </div>
  );
};

export default MicButton;